import { useEffect, useRef, useState } from "react"
import type { Event } from "@apps/gwservice/types"
import { CalendarView } from "./calendar-view"
import { buildDayMap } from "./utils"

type Props = {
  events: Event[]
  children: React.ReactNode
}

export function ScrollCalendar({ events, children }: Props) {
  const scrollRef = useRef<HTMLDivElement>(null)
  const calendarRef = useRef<HTMLDivElement>(null)
  const lastY = useRef(0)
  const [state, setState] = useState<"normal" | "hidden" | "visible">("normal")
  const dayMap = buildDayMap(events)

  if (false)
    useEffect(() => {
      const element = scrollRef.current
      if (!element) return

      const height = calendarRef.current?.offsetHeight ?? 0
      const onScroll = () => {
        const y = element.scrollTop
        setState(y < height ? "normal" : y > lastY.current ? "hidden" : "visible")
        lastY.current = y
      }

      element.addEventListener("scroll", onScroll, { passive: true })
      return () => element.removeEventListener("scroll", onScroll)
    }, [])

  const fixed = state !== "normal"

  return (
    <div ref={scrollRef} className="h-full overflow-y-auto flex flex-col">
      <div ref={calendarRef} className={fixed ? "invisible" : ""}><CalendarView dayMap={dayMap} /></div>
      <div className={`fixed top-[var(--offline-banner-h,0px)] inset-x-0 z-10 bg-background transition-transform duration-300${fixed ? state === "visible" ? " translate-y-0" : " -translate-y-full" : " hidden"}`}>
        <CalendarView dayMap={dayMap} />
      </div>
      {children}
    </div>
  )
}
